// client/src/App.js

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../../App.css";
import CommonContext from '../../commonContext';

import {
  Button,
  Flex,
  Stack,
  useToast,
  Box,
  Text,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import { IoChevronBack } from "react-icons/io5";
import { postCall } from '../../utils/requests';
import Utils from '../../utils/utils';
import { AiFillSave } from "react-icons/ai";


import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';

import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { SortableItem } from '../../components/SortableItem';



function SortCategories() {

  /* TODO const navigate = useNavigate(); */
  const commonContext = React.useContext(CommonContext);

  const logout = () => {
    console.log("logout")
    localStorage.removeItem("accessToken");
    /* TODO navigate('/'); */
  }

  /* utils */
  const toast = useToast();


  /* delete form */
  const navigate = useNavigate();
  const [allData, setAllData] = React.useState([])
  const [originalData, setOriginalData] = React.useState([])
  const [selectedCategory, setSelectedCategory] = React.useState("0")
  const [selectedName, setSelectedName] = React.useState("")
  const [isOpenAlertConfirm, setIsOpenAlertConfirm] = React.useState(false)
  const cancelRef = React.useRef()

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );



  const handleGoBack = () => {
    if (selectedCategory !== "0") {
      setSelectedCategory("0")
      setSelectedName("")
      return
    } else {
      if (JSON.stringify(originalData) !== JSON.stringify(allData)) {
        openAlertConfirm()
      } else {
        navigate(-1)

      }
    }
  };

  const openAlertConfirm = () => setIsOpenAlertConfirm(true)

  const onCloseAlertConfirm = (e) => {
    setIsOpenAlertConfirm(false)
    if (e.target.innerHTML === "Si") {
      navigate(-1)
    }
  }

  const fetchCategories = async () => {


    postCall("/fetchCat", {}).then((data) => {


      setAllData(Array.from(data.data.map((item) => {

        console.log(item)

        return {
          id: item.id_category,
          name: item.name,
          advices: item.advices,
          trainWithMe: item.train_with_me,
          created_at: Utils.convertDateToIta(item.creation_date, true),
          in_home: item.in_home,
          creation_date: item.creation_date,
          has_subcat: item.has_subcat ?? "0",
          id_father: item.id_father

        }
      })));

      setOriginalData(Array.from(data.data.map((item) => {
        return {
          id: item.id_category,
          name: item.name,
          advices: item.advices,
          trainWithMe: item.train_with_me,
          created_at: Utils.convertDateToIta(item.creation_date, true),
          in_home: item.in_home,
          creation_date: item.creation_date,
          has_subcat: item.has_subcat ?? "0",
          id_father: item.id_father

        }
      })));
    });
  }

  useEffect(() => {
    fetchCategories()
    commonContext.setCurrentPath("Categorie")
    commonContext.setCurrentPage("categorieslist")

  }, []);

  const handleSubmit = async () => {

    postCall("/sortCategories", {
      categories: JSON.stringify(allData)
    }).then((data) => {
      if (data.status === "success") {
        toast({
          title: "Perfetto",
          description: "Ordinamento salvato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })

        fetchCategories()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }
    });
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active.id !== over.id) {
      setAllData((items) => {
        const oldIndex = items.indexOf(items.filter(obj => obj.id === active.id)[0]);
        const newIndex = items.indexOf(items.filter(obj => obj.id === over.id)[0]);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }

  const updateCurrentCat = (id, name) => {
    setSelectedCategory(id)
    setSelectedName(name)

  }


  return (
    <div style={{ "width": "100%", textAlign: "center", height: "100%", overflowY: "scroll" }}>

      {/* BEGIN - ALERT ask confirmation */}
      <AlertDialog
        isOpen={isOpenAlertConfirm}
        leastDestructiveRef={cancelRef}
        onClose={onCloseAlertConfirm}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              ATTENZIONE
            </AlertDialogHeader>

            <AlertDialogBody>
              Sei sicuro di voler tornare indietro senza salvare le modifiche effettuate?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseAlertConfirm}>
                No
              </Button>
              <Button colorScheme='red' onClick={onCloseAlertConfirm} ml={3}>
                Si
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* END - ALERT ask confirmation*/}

      {/* BEGIN - TOP ROW */}
      <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">
        <Flex justifyContent="left" w="100%" >
          <Button mr="20px" leftIcon={<IoChevronBack />} colorScheme='green' variant='solid' onClick={() => { handleGoBack() }}>
            Indietro
          </Button>
          <Button isDisabled={JSON.stringify(originalData) === JSON.stringify(allData)} mr="20px" leftIcon={<AiFillSave />} colorScheme="orange" variant='solid' onClick={() => { handleSubmit() }}>
            Salva
          </Button>

        </Flex>

      </Stack>
      <Stack direction='row' spacing={4} justifyContent="center">
        {selectedCategory !== "0" && selectedName !== "" &&
          <Flex>
            <Text
              mb="30px"
              fontSize="2xl"
            >Sottocategorie di:</Text>
            <Text
              mb="30px"
              ml="10px"
              as="b"
              fontSize="2xl"
            >{selectedName}</Text>
          </Flex>
        }
      </Stack>
      <Stack direction='row' spacing={4} justifyContent="center">


        <Text
          mb="30px"
          ml="10px"
          as="b"
          color="red"
          fontSize="lg"
        >Trascina le categorie per ordinarle e premi il tasto Salva per applicare le modifiche</Text>

      </Stack>
      {/* END - TOP ROW */}
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        justifyContent="center"
        textAlign="center"
        align="center"
      >

        <Box
          w="100%"
          align="center"
          justifyContent="center"
          pb="180px"
        >

          <SortableContext
            items={allData}
            strategy={verticalListSortingStrategy}
            align="center"
            justifyContent="center"
          >
            {allData.map(category => ((selectedCategory === category.id_father || (selectedCategory === "0" && category.id_father === 0)) &&
              <Box display="flex" alignItems="center">
                <SortableItem
                  key={category.id}
                  id={category.id}
                  name={category.name}
                  hasSubcat={category.has_subcat}
                  myfunc={updateCurrentCat}
                />


              </Box>
            ))}
          </SortableContext>
        </Box>

      </DndContext>
    </div>
  );

}

export default SortCategories;